// A one-point view of a room, drawn to show what a VRV indoor unit looks
// like once it is in: the grilles, the panel or the unit, in its colour.
// Not to scale. Used by IndoorUnitLooks.jsx on the VRV page.
// Generated from the approved v8 mockup's drawings; edit the shapes here.

const DEF = { panel: '#f8fafc', grille: '#eef2f7', slot: '#64748b', base: '#f8fafc', perf: '#cbd5e1' };

// The room: ceiling, side walls, back wall and floor. slab: an exposed slab
// (no false ceiling), drawn a shade darker.
function Backdrop({ slab }) {
  return (
    <>
      <polygon points="0,0 400,0 300,55 100,55" fill={slab ? '#e7e5e4' : '#f1f5f9'} />
      <polygon points="0,0 100,55 100,165 0,220" fill="#e2e8f0" />
      <polygon points="400,0 300,55 300,165 400,220" fill="#e2e8f0" />
      <rect x="100" y="55" width="200" height="110" fill="#f8fafc" />
      <polygon points="0,220 400,220 300,165 100,165" fill="#e7e5e4" />
      <path d="M0 0L100 55H300L400 0M100 55V165M300 55V165M0 220L100 165H300L400 220" fill="none" stroke="#cbd5e1" strokeWidth="1" />
    </>
  );
}

function Shapes({ kind, c }) {
  switch (kind) {
    case 'duct':
      return (
        <>
        <Backdrop />
        <polygon points="131.8,41.8 268.2,41.8 263.8,46.2 136.2,46.2" fill={c.grille} stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="139.2" y1="43.2" x2="260.8" y2="43.2" stroke={c.slot} strokeWidth="1.6" strokeLinecap="round" />
        <line x1="140.8" y1="44.8" x2="259.2" y2="44.8" stroke={c.slot} strokeWidth="1.6" strokeLinecap="round" />
        <polygon points="173.3,12.1 226.7,12.1 223.1,25.3 176.9,25.3" fill={c.grille} stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="179.2" y1="14.9" x2="220.8" y2="14.9" stroke={c.slot} strokeWidth="1.2" strokeLinecap="round" />
        <line x1="179.7" y1="17.1" x2="220.3" y2="17.1" stroke={c.slot} strokeWidth="1.2" strokeLinecap="round" />
        <line x1="180.2" y1="19.2" x2="219.8" y2="19.2" stroke={c.slot} strokeWidth="1.2" strokeLinecap="round" />
        <line x1="180.7" y1="21.4" x2="219.3" y2="21.4" stroke={c.slot} strokeWidth="1.2" strokeLinecap="round" />
        <line x1="181.2" y1="23.6" x2="218.8" y2="23.6" stroke={c.slot} strokeWidth="1.2" strokeLinecap="round" />
        <line x1="165" y1="48" x2="150" y2="82" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="150,82 149.3,74 156.3,77.1" fill="#60a5fa" />
        <line x1="235" y1="48" x2="250" y2="82" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="250,82 243.7,77.1 250.7,74" fill="#60a5fa" />
        <text x="275.6" y="46" textAnchor="start" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">SUPPLY GRILLE</text>
        <text x="234.2" y="21" textAnchor="start" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">RETURN GRILLE</text>
        </>
      );
    case 'hall':
      return (
        <>
        <Backdrop />
        <polygon points="83.5,9.9 116.3,9.9 122.7,17.6 92.5,17.6" fill={c.grille} stroke="#94a3b8" strokeWidth="1.2" />
        <polygon points="93.8,11.8 109.9,11.8 113.4,15.7 98,15.7" fill="none" stroke={c.slot} strokeWidth="1.2" />
        <polygon points="109.8,32.5 135.1,32.5 141.6,40.1 118.7,40.1" fill={c.grille} stroke="#94a3b8" strokeWidth="1.2" />
        <polygon points="118.2,34.4 130.6,34.4 134.1,38.2 122.4,38.2" fill="none" stroke={c.slot} strokeWidth="1.2" />
        <polygon points="183.6,9.9 216.4,9.9 215.1,17.6 184.9,17.6" fill={c.grille} stroke="#94a3b8" strokeWidth="1.2" />
        <polygon points="192,11.8 208,11.8 207.7,15.7 192.3,15.7" fill="none" stroke={c.slot} strokeWidth="1.2" />
        <polygon points="187.3,32.5 212.7,32.5 211.4,40.1 188.6,40.1" fill={c.grille} stroke="#94a3b8" strokeWidth="1.2" />
        <polygon points="193.8,34.4 206.2,34.4 205.9,38.2 194.1,38.2" fill="none" stroke={c.slot} strokeWidth="1.2" />
        <polygon points="283.7,9.9 316.5,9.9 307.5,17.6 277.3,17.6" fill={c.grille} stroke="#94a3b8" strokeWidth="1.2" />
        <polygon points="290.1,11.8 306.2,11.8 302,15.7 286.6,15.7" fill="none" stroke={c.slot} strokeWidth="1.2" />
        <polygon points="264.9,32.5 290.2,32.5 281.3,40.1 258.4,40.1" fill={c.grille} stroke="#94a3b8" strokeWidth="1.2" />
        <polygon points="269.4,34.4 281.8,34.4 277.6,38.2 265.9,38.2" fill="none" stroke={c.slot} strokeWidth="1.2" />
        <text x="200" y="92" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">ONLY THE GRILLES SHOW</text>
        </>
      );
    case 'tile':
      return (
        <>
        <Backdrop />
        <line x1="50" y1="0" x2="125" y2="55" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="110" y1="0" x2="155" y2="55" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="170" y1="0" x2="185" y2="55" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="230" y1="0" x2="215" y2="55" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="290" y1="0" x2="245" y2="55" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="350" y1="0" x2="275" y2="55" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="15" y1="8.2" x2="385" y2="8.2" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="35" y1="19.2" x2="365" y2="19.2" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="55" y1="30.3" x2="345" y2="30.3" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="75" y1="41.2" x2="325" y2="41.2" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <line x1="95" y1="52.2" x2="305" y2="52.2" stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" />
        <ellipse cx="153.5" cy="24.8" rx="9" ry="3.2" fill="#fef9c3" stroke="#eab308" strokeWidth="1" />
        <ellipse cx="246.5" cy="24.8" rx="9" ry="3.2" fill="#fef9c3" stroke="#eab308" strokeWidth="1" />
        <polygon points="175.2,19.2 224.8,19.2 221.8,30.3 178.2,30.3" fill={c.panel} stroke="#94a3b8" strokeWidth="1.2" />
        <polygon points="188,22 212,22 211.2,27.5 188.8,27.5" fill={c.grille} stroke="#94a3b8" strokeWidth="0.8" />
        <line x1="190.5" y1="23.1" x2="209.5" y2="23.1" stroke="#94a3b8" strokeWidth="0.8" strokeLinecap="round" />
        <line x1="190.7" y1="24.5" x2="209.3" y2="24.5" stroke="#94a3b8" strokeWidth="0.8" strokeLinecap="round" />
        <line x1="190.8" y1="25.8" x2="209.2" y2="25.8" stroke="#94a3b8" strokeWidth="0.8" strokeLinecap="round" />
        <line x1="191" y1="27.2" x2="209" y2="27.2" stroke="#94a3b8" strokeWidth="0.8" strokeLinecap="round" />
        <line x1="180.4" y1="20.4" x2="219.6" y2="20.4" stroke={c.slot} strokeWidth="1.4" strokeLinecap="round" />
        <line x1="182.4" y1="29.2" x2="217.6" y2="29.2" stroke={c.slot} strokeWidth="1.4" strokeLinecap="round" />
        <line x1="179" y1="21.2" x2="180.7" y2="28.3" stroke={c.slot} strokeWidth="1.4" strokeLinecap="round" />
        <line x1="221" y1="21.2" x2="219.3" y2="28.3" stroke={c.slot} strokeWidth="1.4" strokeLinecap="round" />
        <text x="200" y="82" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">ONE 600 × 600 CEILING TILE</text>
        <text x="200" y="94" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">LIGHTS IN THE NEXT TILES</text>
        </>
      );
    case 'square':
      return (
        <>
        <Backdrop />
        <polygon points="155.3,15.4 244.7,15.4 233.8,38.5 166.2,38.5" fill={c.panel} stroke="#94a3b8" strokeWidth="1.2" />
        <polygon points="166.6,18.2 233.4,18.2 227,35.8 173,35.8" fill="none" stroke={c.slot} strokeWidth="2" />
        <polygon points="180.8,22 219.2,22 217,31.9 183,31.9" fill={c.grille} stroke={c.slot} strokeWidth="0.8" />
        <line x1="184.3" y1="23.6" x2="215.7" y2="23.6" stroke={c.slot} strokeWidth="0.8" strokeLinecap="round" />
        <line x1="184.6" y1="25.3" x2="215.4" y2="25.3" stroke={c.slot} strokeWidth="0.8" strokeLinecap="round" />
        <line x1="184.9" y1="26.9" x2="215.1" y2="26.9" stroke={c.slot} strokeWidth="0.8" strokeLinecap="round" />
        <line x1="185.2" y1="28.6" x2="214.8" y2="28.6" stroke={c.slot} strokeWidth="0.8" strokeLinecap="round" />
        <line x1="185.5" y1="30.3" x2="214.5" y2="30.3" stroke={c.slot} strokeWidth="0.8" strokeLinecap="round" />
        <line x1="168.5" y1="27.5" x2="128" y2="60" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="128,60 131.1,52.6 135.9,58.6" fill="#60a5fa" />
        <line x1="231.5" y1="27.5" x2="272" y2="60" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="272,60 264.1,58.6 268.9,52.6" fill="#60a5fa" />
        <text x="200" y="82" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">950 × 950 mm PANEL</text>
        </>
      );
    case 'long':
      return (
        <>
        <Backdrop />
        <polygon points="132.8,22 267.2,22 258.8,33 141.2,33" fill={c.panel} stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="140.3" y1="23.6" x2="259.7" y2="23.6" stroke={c.slot} strokeWidth="1.6" strokeLinecap="round" />
        <line x1="145.7" y1="31.3" x2="254.3" y2="31.3" stroke={c.slot} strokeWidth="1.6" strokeLinecap="round" />
        <line x1="150" y1="33" x2="136" y2="66" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="136,66 135.2,58 142.3,61" fill="#60a5fa" />
        <line x1="250" y1="33" x2="264" y2="66" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="264,66 257.7,61 264.8,58" fill="#60a5fa" />
        <text x="200" y="82" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">LONG, NARROW PANEL</text>
        </>
      );
    case 'corner':
      return (
        <>
        <Backdrop />
        {/* the panel: a strip in the surface colour on the room side, with the
            air outlet, and the suction grille in the base colour by the wall */}
        <polygon points="148.4,44 251.6,44 243.4,54.5 156.6,54.5" fill={c.base} stroke="#94a3b8" strokeWidth="1" />
        <polygon points="148.4,44 251.6,44 248.8,47.6 151.2,47.6" fill={c.panel} stroke="#94a3b8" strokeWidth="0.6" />
        <line x1="154.6" y1="45.9" x2="245.4" y2="45.9" stroke={c.slot} strokeWidth="1.4" strokeLinecap="round" />
        <line x1="160" y1="49" x2="240" y2="49" stroke={c.perf} strokeWidth="1" strokeLinecap="round" />
        <line x1="161.1" y1="50.6" x2="238.9" y2="50.6" stroke={c.perf} strokeWidth="1" strokeLinecap="round" />
        <line x1="162.2" y1="52.3" x2="237.8" y2="52.3" stroke={c.perf} strokeWidth="1" strokeLinecap="round" />
        <line x1="180" y1="47" x2="168" y2="82" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="168,82 166.6,74.1 173.9,76.6" fill="#60a5fa" />
        <line x1="220" y1="47" x2="232" y2="82" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="232,82 226.1,76.6 233.4,74.1" fill="#60a5fa" />
        <text x="200" y="30" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">SLIM PANEL ALONG THE WALL</text>
        </>
      );
    case 'susp':
      return (
        <>
        <Backdrop slab />
        <rect x="124" y="50" width="152" height="22" rx="6" fill={c.panel} stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="134" y1="66" x2="266" y2="66" stroke={c.slot} strokeWidth="1.6" strokeLinecap="round" />
        <line x1="170" y1="74" x2="154" y2="106" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="154,106 153.7,98 160.6,101.4" fill="#60a5fa" />
        <line x1="230" y1="74" x2="246" y2="106" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="246,106 239.4,101.4 246.3,98" fill="#60a5fa" />
        <text x="200" y="22" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">NO FALSE CEILING</text>
        </>
      );
    case 'susp4':
      return (
        <>
        <Backdrop slab />
        <rect x="150" y="24" width="100" height="18" rx="9" fill={c.panel} stroke="#94a3b8" strokeWidth="1.2" />
        <rect x="157" y="38" width="86" height="8" rx="4" fill={c.grille} stroke="#94a3b8" strokeWidth="0.8" />
        <line x1="164" y1="42" x2="236" y2="42" stroke={c.slot} strokeWidth="1.4" strokeLinecap="round" />
        <line x1="156" y1="46" x2="128" y2="76" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="128,76 130,68.3 135.6,73.5" fill="#60a5fa" />
        <line x1="244" y1="46" x2="272" y2="76" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="272,76 264.4,73.5 270,68.3" fill="#60a5fa" />
        <text x="200" y="14" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">NO FALSE CEILING</text>
        </>
      );
    case 'wall':
      return (
        <>
        <Backdrop />
        <rect x="148" y="70" width="104" height="28" rx="8" fill={c.panel} stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="158" y1="93" x2="242" y2="93" stroke={c.slot} strokeWidth="1.6" strokeLinecap="round" />
        <line x1="176" y1="101" x2="166" y2="130" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="166,130 164.7,122.1 171.9,124.6" fill="#60a5fa" />
        <line x1="224" y1="101" x2="234" y2="130" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="234,130 228.1,124.6 235.3,122.1" fill="#60a5fa" />
        <text x="200" y="24" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">NO FALSE CEILING</text>
        </>
      );
    case 'floor':
      return (
        <>
        <Backdrop />
        <rect x="128" y="66" width="144" height="58" rx="0" fill="#dbeafe" stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="200" y1="66" x2="200" y2="124" stroke="#94a3b8" strokeWidth="1.2" strokeLinecap="round" />
        <rect x="136" y="132" width="128" height="36" rx="4" fill={c.panel} stroke="#a8a29e" strokeWidth="1.2" />
        <rect x="146" y="135" width="108" height="6" rx="2" fill={c.grille} stroke="#a8a29e" strokeWidth="0.8" />
        <line x1="176" y1="131" x2="170" y2="104" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="170,104 175.3,110 167.8,111.7" fill="#60a5fa" />
        <line x1="224" y1="131" x2="230" y2="104" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="230,104 232.2,111.7 224.7,110" fill="#60a5fa" />
        <text x="200" y="24" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">UNDER THE WINDOW</text>
        </>
      );
    case 'floorhidden':
      return (
        <>
        <Backdrop />
        <rect x="128" y="66" width="144" height="52" rx="0" fill="#dbeafe" stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="200" y1="66" x2="200" y2="118" stroke="#94a3b8" strokeWidth="1.2" strokeLinecap="round" />
        <polygon points="106,124 294,124 300,130 100,130" fill="#e7d8bf" stroke="#a8a29e" strokeWidth="1" />
        <rect x="100" y="130" width="200" height="42" rx="0" fill="#d6c3a5" stroke="#a8a29e" strokeWidth="1" />
        <polygon points="150,125 250,125 252,129 148,129" fill="#57534e" />
        <rect x="140" y="150" width="120" height="12" rx="2" fill="#78716c" stroke="none" strokeWidth="0" />
        <line x1="148" y1="152" x2="148" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="156" y1="152" x2="156" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="164" y1="152" x2="164" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="172" y1="152" x2="172" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="180" y1="152" x2="180" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="188" y1="152" x2="188" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="196" y1="152" x2="196" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="204" y1="152" x2="204" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="212" y1="152" x2="212" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="220" y1="152" x2="220" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="228" y1="152" x2="228" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="236" y1="152" x2="236" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="244" y1="152" x2="244" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="252" y1="152" x2="252" y2="160" stroke="#a8a29e" strokeWidth="1" strokeLinecap="round" />
        <line x1="180" y1="123" x2="176" y2="98" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="176,98 180.9,104.3 173.3,105.5" fill="#60a5fa" />
        <line x1="220" y1="123" x2="224" y2="98" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="224,98 226.7,105.5 219.1,104.3" fill="#60a5fa" />
        <text x="200" y="24" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">HIDDEN IN YOUR BOXING</text>
        </>
      );
    case 'cube':
      return (
        <>
        <Backdrop />
        <line x1="250" y1="160" x2="250" y2="184" stroke="#64748b" strokeWidth="3" strokeLinecap="round" />
        <line x1="290" y1="160" x2="290" y2="184" stroke="#64748b" strokeWidth="3" strokeLinecap="round" />
        <line x1="242" y1="184" x2="298" y2="184" stroke="#64748b" strokeWidth="3" strokeLinecap="round" />
        <rect x="240" y="112" width="60" height="50" rx="4" fill={c.panel} stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="248" y1="120" x2="292" y2="120" stroke="#94a3b8" strokeWidth="1" strokeLinecap="round" />
        <line x1="248" y1="126" x2="292" y2="126" stroke="#94a3b8" strokeWidth="1" strokeLinecap="round" />
        <line x1="248" y1="132" x2="292" y2="132" stroke="#94a3b8" strokeWidth="1" strokeLinecap="round" />
        <line x1="238" y1="128" x2="196" y2="142" stroke="#60a5fa" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="196,142 201.4,136.1 203.9,143.4" fill="#60a5fa" />
        <text x="200" y="24" textAnchor="middle" fontSize="9" fontWeight="700" letterSpacing="0.6" fill="#64748b">ON A STAND, OR HUNG</text>
        </>
      );
    default:
      return null;
  }
}

export default function RoomView({ kind, colour, label, className = '' }) {
  const c = { ...DEF, ...(colour || {}) };
  return (
    <svg viewBox="0 0 400 220" className={`block h-auto w-full ${className}`} role={label ? 'img' : undefined}
      aria-label={label} aria-hidden={label ? undefined : 'true'}>
      <Shapes kind={kind} c={c} />
    </svg>
  );
}
